import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { createRequestUserYearInReviewReportAction, IRequestUserYearInReviewReportAction } from '../actions/ProfileActions';
import { ICanRequestYearInReviewReportState } from '../reducers/ProfileReducers';
import { IState } from '../state/State';

export interface IYearInReviewLinkBodyProps {
    canRequestYearInReviewReport: ICanRequestYearInReviewReportState,
    requestYearInReviewReport: (year: number) => IRequestUserYearInReviewReportAction;
  }

  const handleRequestYearInReviewReportButtonClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, props: IYearInReviewLinkBodyProps, year: number) => {
    props.requestYearInReviewReport(year);
  }

const YearInReviewLinkBody: React.FC<IYearInReviewLinkBodyProps> = (props: IYearInReviewLinkBodyProps) => {
    let exportDataView = null;
    let canRequestReport = props?.canRequestYearInReviewReport?.result?.canRequest ?? false;
    let acceptedYears: number[] = props?.canRequestYearInReviewReport?.result?.acceptedYears ?? [];

    const [selectedYear, setSelectedYear] = useState<number | ''>('');
    const [requestedYear, setRequestedYear] = useState<number | null>(null);

    const handleYearChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedYear(e.target.value ? parseInt(e.target.value) : '');
    }, []);

    const handleDownloadClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
      if (selectedYear) {
        handleRequestYearInReviewReportButtonClick(e, props, selectedYear);
        setRequestedYear(selectedYear);
      }
    }, [selectedYear, props]);

    if (canRequestReport) {
      const exportableYears = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018]
        .filter(year => acceptedYears.includes(year));

      return (
        <div>
          <p className="ProfileSubtitle">Year In Review</p>
          <div className="YearInReviewLinkBody">
            <p>Your Rhythm Horizon Year In Review report is ready for download! Select a year and click download to have an e-mail sent to you with your review.</p>
            <br />
            <table className="YearInReviewTable">
              <tbody>
                <tr>
                  <td>
                    <div className="YearInReviewControls">
                      <select 
                        value={selectedYear} 
                        onChange={handleYearChange}
                        className="YearInReviewSelect"
                      >
                        <option value="">Select a year</option>
                        {exportableYears.map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                      <button 
                        onClick={handleDownloadClick}
                        disabled={!selectedYear}
                        className="YearInReviewDownloadButton"
                      >
                        Download Report
                      </button>
                    </div>
                  </td>
                </tr>
                {requestedYear && (
                  <tr>
                    <td>
                      <p className="YearInReviewRequestSentText">
                        Your year in review request for {requestedYear} was sent to the server. 
                        You should receive an e-mail to your login e-mail address shortly with a link to download your report.
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
    else {
      return <div/>;
    }
  }

  const mapStateToProps = (state: IState) => ({
    canRequestYearInReviewReport: state.canRequestYearInReviewReport,
  });

  const actionCreators = {
    requestYearInReviewReport: createRequestUserYearInReviewReportAction,
  }
  
  export default connect(mapStateToProps, actionCreators)(YearInReviewLinkBody);
